export enum TemplateActionType {
    create,
    edit,
    duplicate,
    delete,
}
